import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const MESSAGE_PERMISSIONS = { READ: PERMISSIONS.AUDIT_READ };
export const MESSAGE_QUERY_KEYS = queryKeys.messages;
